import { useCallback } from "react";
import { readTokenFromLocalStorage } from "./useToken";

interface ITokenPayload {
    sub: string;
    company_id: string;
    role: string;
    preferred_username?: string;
    [key: string]: any;
}

export const useTokenData = () => {
    // Получение полных данных токена
    const getToken = useCallback(() => {
        return readTokenFromLocalStorage();
    }, []);

    // Получение payload (декодированной части) токена
    const getTokenPayload = useCallback((): ITokenPayload | null => {
        try {
            const token = readTokenFromLocalStorage();
            if (!token) return null;
            
            const accessToken = token.getAccessToken();
            if (!accessToken || !accessToken.value) return null;
            
            const payload = JSON.parse(atob(accessToken.value.split('.')[1])) as ITokenPayload;
            return payload;
        } catch (error) {
            console.error('Error parsing token payload:', error);
            return null;
        }
    }, []);

    // Получение userId из токена
    const getUserId = useCallback((): string | null => {
        const payload = getTokenPayload();
        return payload?.sub || null;
    }, [getTokenPayload]);

    // Получение companyId из токена
    const getCompanyId = useCallback((): string | null => {
        const payload = getTokenPayload();
        return payload?.company_id || null;
    }, [getTokenPayload]);

    // Получение роли пользователя
    const getRole = useCallback((): string | string [] | null => {
        const payload = getTokenPayload();
        return payload?.role || null;
    }, [getTokenPayload]);

    // Получение username
    const getUserName = useCallback((): string | null => {
        const payload = getTokenPayload();
        return payload?.preferred_username || payload?.unique_name || null;
    }, [getTokenPayload]);

    // Проверка валидности токена
    const isTokenValid = useCallback((): boolean => {
        const token = readTokenFromLocalStorage();
        if (!token) return false;
        
        const accessToken = token.getAccessToken();
        if (!accessToken || !accessToken.value) return false;
        
        try {
            const payload = JSON.parse(atob(accessToken.value.split('.')[1]));
            const exp = payload.exp;
            if (!exp) return false;
            
            // Проверяем, не истек ли токен (exp в секундах)
            const now = Math.floor(Date.now() / 1000);
            return exp > now;
        } catch (error) {
            console.error('Error checking token validity:', error);
            return false;
        }
    }, []);

    return {
        getToken,
        getTokenPayload,
        getUserId,
        getCompanyId,
        getRole,
        getUserName,
        isTokenValid,
    };
};